var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthrsIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.87,
    height: 30.719,
    viewBox: "0 0 30.87 30.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.142,
    y1: 0.791,
    x2: 1,
    y2: 0.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M11.883,6.511h0A3.845,3.845,0,1,0,6.355,1.166L4.824,2.746C-.96,8.737-1.631,18.014,3.277,24.327a16.564,16.564,0,0,0,1.605,1.8,16.289,16.289,0,0,0,23.038-.389l1.87-1.936a3.845,3.845,0,0,0-5.528-5.346L22.392,20.4a8.612,8.612,0,0,1-13.4-1.283A8.778,8.778,0,0,1,10.236,8.232L11.907,6.5H11.9Z",
    transform: "translate(0.002 0.007)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthrsIconColor);
export default __webpack_public_path__ + "static/media/othrsIconColor.00f6ae48dd60f1da6d37d905f818c7b8.svg";
export { ForwardRef as ReactComponent };